import {I18n} from 'aws-amplify/utils';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {DomainName} from '../types';
import {
    ActionIcon,
    Group
} from "@mantine/core";
import {AiOutlineLink} from "react-icons/ai";
import {DataTableColumn} from "mantine-datatable";

export const columns: DataTableColumn<DomainName>[] = [
    {
        accessor: 'name',
        title: I18n.get('Name'),
        // FNP-1284 - NO WIDTH ON THE FLEXIBLE COLUMN. Leave it that way.
        //
        // A column with no width takes the space the fixed columns leave. A grid
        // fraction here made it content-size instead: the fixed columns are
        // committed first and this one grew to fit its longest value, pushing the
        // table past its container and raising a horizontal scrollbar.
        //
        // `minWidth` in px is fine if a floor is ever wanted. A grid fraction is
        // not: mantine-datatable puts the value in an inline style on a real
        // <table> cell, where `fr` is not a valid unit.
        render: (item: DomainName) => <Group>
            <NavLink to={`/domain-names/${item.id}`}>{item.name}</NavLink>
            {/* FNP-1282: icon-only, so the label IS the accessible name. Without
                it a screen reader announces only "button". Named per row so the
                announcement says WHICH site it opens. */}
            <ActionIcon
                variant={"subtle"}
                aria-label={`Open ${item.name ?? 'site'} in a new tab`}
                title={`Open ${item.name ?? 'site'} in a new tab`}
                onClick={() => window.open('http://' + item.name)}>
                <AiOutlineLink/>
            </ActionIcon>
        </Group>,
    },
    {
        accessor: 'registrarId',
        title: I18n.get('Registrar'),
        render: (item: DomainName) => <NavLink to={`/registrars/${item.registrarId}`}>{item.registrar?.name}</NavLink>,
    },
    {
        accessor: 'category',
        title: I18n.get('Category'),
        render: (item: DomainName) => item.category,
    },
    {
        accessor: 'tldId',
        title: I18n.get('TLD'),
        render: (item: DomainName) => <NavLink
            to={`/top-level-domains/${item.tldId}`}>{item.topLevelDomain?.name}</NavLink>,
    },
    {
        accessor: 'created',
        title: I18n.get('Created'),
        render: (item: DomainName) => formatTimestamp(item.created),
    },
];
